import { useCheckPrivatePlacementTrait } from '../../../../basic-info/hooks/useCheckPrivatePlacementTrait';
import {
  useOfferingSetup_Header_PrivateOfferingQuery,
  useOfferingSetup_Header_PublishedOfferingQuery,
} from '../../../../graphql';

export function useOfferingSetupHeaderQuery({
  offeringId,
  skip,
}: {
  offeringId?: string;
  skip: boolean;
}) {
  const hasPrivatePlacementTrait = useCheckPrivatePlacementTrait();

  const {
    data: privateData,
    loading: privateLoading,
    error: privateError,
  } = useOfferingSetup_Header_PrivateOfferingQuery({
    variables: { offeringId: offeringId! },
    skip,
    fetchPolicy: 'cache-and-network',
  });

  const {
    data: publishedData,
    loading: publishedLoading,
    error: publishedError,
  } = useOfferingSetup_Header_PublishedOfferingQuery({
    variables: {
      offeringId: offeringId!,
      includePrivatePlacementOfferings: hasPrivatePlacementTrait,
    },
    skip,
    fetchPolicy: 'no-cache',
  });

  const error = privateError ?? publishedError;

  return {
    offering: error ? null : privateData?.privateOfferings?.items?.[0] ?? null,
    publishedOffering: error ? null : publishedData?.publishedOfferings?.items?.[0] ?? null,
    loading: privateLoading ?? publishedLoading,
    error,
  };
}
